import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme: any) => ({
  root: {
    background: theme.palette.brand.white,
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    fontSize: 14,
    fontWeight: 'bold',
    minWidth: 100,
    boxShadow: theme.boxShadow.main,
  },
}));

export default function GlowingButton({ children, ...props }) {
  const classes = useStyles();
  return (
    <Button variant="outlined" className={classes.root} {...props}>
      {children}
    </Button>
  );
}
